<span #animatedDigit  class="animated-digit">{{animatedDigit.innerText | localizednumber}}
</span>